import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./i18n";
import "bootstrap/dist/css/bootstrap.min.css";
import UserPreferenceProvider from "./context/UserPreferenceContext";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <UserPreferenceProvider>
      <App />
    </UserPreferenceProvider>
  </React.StrictMode>
);